import { MenuStates } from '@frontend-site/main-header/domain';
import { SystemDetailsResolver } from '@frontend-site/shared/core';
import { PanayaRoute } from '@frontend-site/shared/router-store';
import { LoopbackComponent } from '@frontend-site/shared/hybrid';
import { SystemUsersResolver } from '../../../../libs/shared/core/src/lib/system/system-users.resolver';

export const SYSTEM_ROUTES: PanayaRoute = Object.freeze<PanayaRoute>({
    path: 'myERPs',
    children: [
        {
            path: ':id',
            resolve: { loadSystemDetails: SystemDetailsResolver, users: SystemUsersResolver },
            data: { navState: 'myERPs.system', menuState: MenuStates.SYSTEM },
            children: [
                {
                    path: 'ERPSnapshot',
                    data: { navState: 'myERPs.system.ERPSnapshot' },
                    children: [
                        {
                            path: '',
                            redirectTo: 'snapshotMain',
                            pathMatch: 'full'
                        },
                        {
                            path: 'snapshotMain',
                            component: LoopbackComponent,
                            data: {
                                navState: 'myERPs.system.ERPSnapshot.snapshotMain',
                                rememberMe: { pageId: 'myERPs_system_ERPSnapshot_snapshotMain', group: 'system' }
                            }
                        },
                        {
                            path: 'sapObjectsGrid',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.ERPSnapshot.sapObjectsGrid' }
                        }
                    ]
                },
                {
                    path: 'testAssets',
                    data: { navState: 'myERPs.system.testAssets', rememberMe: { pageId: 'myERPs_system_testAssets', group: 'system' } },
                    children: [
                        {
                            path: '',
                            redirectTo: 'testCoverage',
                            pathMatch: 'full'
                        },
                        {
                            path: 'panayaTests',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.testAssets.panayaTests', rememberMe: true }
                        },
                        {
                            path: 'panayaTestsbyUserType/:userType',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.testAssets.panayaTestsbyUserType' }
                        },
                        {
                            path: 'migratedTests',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.testAssets.migratedTests' }
                        },
                        {
                            path: 'testCoverage',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.testAssets.testCoverage' }
                        },
                        {
                            path: 'sapObjectsGrid',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.testAssets.sapObjectsGrid' }
                        }
                    ]
                },
                {
                    path: 'organizationOverview',
                    data: { navState: 'myERPs.system.organizationOverview' },
                    children: [
                        {
                            path: '',
                            redirectTo: 'dashboard',
                            pathMatch: 'full'
                        },
                        {
                            path: 'dashboard',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.organizationOverview.dashboard' }
                        },
                        {
                            path: 'componentDetails',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.organizationOverview.componentDetails' }
                        },
                        {
                            path: 'potentialTechnicalDebt',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.organizationOverview.potentialTechnicalDebt' }
                        }
                    ]
                },
                {
                    path: 'projects',
                    component: LoopbackComponent,
                    data: { navState: 'myERPs.system.projects', rememberMe: true }
                },
                {
                    path: 'discovery',
                    component: LoopbackComponent,
                    data: { navState: 'myERPs.system.discovery', rememberMe: true }
                },
                {
                    path: 'fitness',
                    component: LoopbackComponent,
                    data: { navState: 'myERPs.system.fitness', rememberMe: { pageId: 'myERPs_system_fitness', group: 'system' } }
                },
                {
                    path: 'satellite',
                    data: {
                        navState: 'myERPs.system.satelliteMain',
                        rememberMe: { pageId: 'myERPs_system_satelliteMain', group: 'system' }
                    },
                    children: [
                        {
                            path: 'graph',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.satelliteMain.graph' }
                        },
                        {
                            path: 'table',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.satelliteMain.table' }
                        },
                        {
                            path: 'table/:systemName',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.satelliteMain.innerTable' }
                        },
                        {
                            path: 'InterfaceAssociation',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.satelliteMain.Require_Manual' }
                        },
                        {
                            path: 'editSystems',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.satelliteMain.editSystems' }
                        },
                        {
                            path: 'interfacesList',
                            component: LoopbackComponent,
                            data: { navState: 'myERPs.system.satelliteMain.interfacesList' }
                        }
                    ]
                },
                {
                    path: 'changeStream',
                    component: LoopbackComponent,
                    data: { navState: 'myERPs.system.changeStream', rememberMe: true }
                }
            ]
        }
    ]
});
